import {Component, Fragment} from 'react'

import LandingCompanyUniverse from './LandingCompanyUniverse.jsx'

import engineering1 from '../../../media/images/sub-universes/engineering/engineering_1.jpg?size=600'
import engineering2 from '../../../media/images/sub-universes/engineering/engineering_2.jpg?size=600'
import engineeringHeader from '../../../media/images/sub-universes/engineering/engineeringHeader.jpg'


const headerBrief = <Fragment>
  <p>Twineeds mobilise un <strong>réseau de consultants spécialisés en ingénierie</strong> pour répondre à vos besoins : <strong>expertise technique, management de transition ou soutien opérationnel</strong>.<br /><br />Mission de maintenance préventive, restructuration d'usine, audit industriel… Nos profils sont <strong>disponibles partout en France</strong>.</p>
</Fragment>

const title = "Renforcez vos équipes | Consultants ingénieurs spécialisés"
const description = "Rencontrez des consultants experts pour répondre à vos besoins: méthode, industrialisation, qualité, process, R&D... Des profils qualifiés d'ingénieurs."

const ourJobsItems = [
  {
    title: 'Ingénieurs généralistes',
    brief: '<p>Des <strong>profils généralistes</strong> en renfort pour vos équipes : <strong>ingénieur mécanique, ingénieur méthodes et process, ingénieur qualité, ingénieur industrialisation, ingénieur production</strong></p>',
    img: engineering1.src,
    imgAlt: 'Consultant spécialisé en maintenance industrielle inspectant un système mécanique'
  },
  {
    title: 'Ingénieurs spécialistes',
    brief: '<p>Faites appel à un <strong>consultant ingénieur spécialisé</strong> : <strong>ingénieur aéronautique, ingénieur agronome, expert automobile, ingénieur mécanique, ingénieur spatial ou encore ingénieur robotique</strong></p>',
    img: engineering2.src,
    imgAlt: 'Équipe de conception technique en train de travailler sur un projet de développement industriel'
  },
]

const specificDifference = <Fragment><strong>Un réseau de consultants spécialisés</strong> pour structurer vos projets transverses et accompagner le changement.</Fragment>

export default class LandingCompanyEngineering extends Component {
  render() {
    return <LandingCompanyUniverse
      headerBrief={headerBrief}
      headerImg={engineeringHeader.src}
      headerImgAlt="Consultants en innovation technologique en pleine collaboration sur un projet d’ingénierie"
      helmet={{title, description}}
      ourJobsItems={ourJobsItems}
      specificDifference={specificDifference}
      title="Trouvez un ingénieur expert qualifié pour vos projets industriels"
      universeCode="engineering"
    />
  }
}
